import React from 'react'
import { renderReact } from '@frontend/utils/react-compat'
import { ReservationDateCard } from './ReservationDateCard'

document.addEventListener('DOMContentLoaded', () => {
  const dataElement = document.querySelector('#data')
  const dataProps = dataElement && dataElement.getAttribute('data-props')
  const props = dataProps === null ? null : (JSON.parse(dataProps) as any)

  if (props === null) {
    throw `props passed by Rails is invalid: ${props}`
  }

  if (props.todayReservationStatus) {
    renderReact(
      <ReservationDateCard
        dateString={props.todayReservationStatus.date}
        statusCode={props.todayReservationStatus.availableStatusCode}
        statusLabel={props.todayReservationStatus.availableStatusText}
        holidayClass={props.todayReservationStatus.weekdayLabel}
        statusSupplement={
          props.todayReservationStatus.availableStatusSupplementText
        }
        acceptanceTime={props.todayReservationStatus.acceptanceTimeText}
        reservationPageUrl={props.todayReservationStatus.applyUrl}
        averageCanceledCount={props.todayReservationStatus.averageCanceledCount}
        note={props.todayReservationStatus.note}
        reservationsCountOverCapacityWhenCongestionOrFull={
          props.todayReservationStatus
            .reservationsCountOverCapacityWhenCongestionOrFull
        }
        applicationStartTimeText={
          props.todayReservationStatus.applicationStartTimeText
        }
        applicationEndTimeText={
          props.todayReservationStatus.applicationEndTimeText
        }
      />,
      document.getElementById('today_reservation_date_card'),
    )
  }
  if (props.nextWorkDayReservationStatus) {
    renderReact(
      <ReservationDateCard
        dateString={props.nextWorkDayReservationStatus.date}
        statusCode={props.nextWorkDayReservationStatus.availableStatusCode}
        statusLabel={props.nextWorkDayReservationStatus.availableStatusText}
        holidayClass={props.nextWorkDayReservationStatus.weekdayLabel}
        statusSupplement={
          props.nextWorkDayReservationStatus.availableStatusSupplementText
        }
        acceptanceTime={props.nextWorkDayReservationStatus.acceptanceTimeText}
        reservationPageUrl={props.nextWorkDayReservationStatus.applyUrl}
        averageCanceledCount={
          props.nextWorkDayReservationStatus.averageCanceledCount
        }
        note={props.nextWorkDayReservationStatus.note}
        reservationsCountOverCapacityWhenCongestionOrFull={
          props.nextWorkDayReservationStatus
            .reservationsCountOverCapacityWhenCongestionOrFull
        }
        applicationStartTimeText={
          props.nextWorkDayReservationStatus.applicationStartTimeText
        }
        applicationEndTimeText={
          props.nextWorkDayReservationStatus.applicationEndTimeText
        }
        style={{ marginTop: '15px' }}
      />,
      document.getElementById('next_work_day_reservation_date_card'),
    )
  }
})
